import Swal from 'sweetalert2';
import { saveActivity, deleteActivity, deleteClassAction } from '@/pages/Stablishments/actions';
import {
  buildRecurringSkipMarker,
  formatDayISO,
  getActivityUserIds,
  hasSkipMarkerForDate,
} from '@/utils/activityUtils';

export default {
  methods: {
    normalizeDeletePayload(payload) {
      if (typeof payload === 'string') {
        const activity = this.activities.find((item) => item._id === payload);
        return { id: payload, activity, day: null };
      }
      return {
        id: payload.id || payload.activity?._id,
        activity: payload.activity,
        day: payload.day || null,
      };
    },
    async unsubscribeAllEnrolledUsers(activity, day = null) {
      const userIds = getActivityUserIds(activity);
      if (!userIds.length) {
        return;
      }

      const activityId = activity._id;
      const dayParam = day
        ? formatDayISO(day)
        : (activity.startDate ? formatDayISO(activity.startDate) : null);

      await Promise.all(
        userIds.map((userId) => deleteClassAction(activityId, userId, dayParam))
      );
    },
    async skipRecurringOnDate(template, day) {
      if (hasSkipMarkerForDate(this.activities, template._id, day)) {
        return;
      }
      await saveActivity(buildRecurringSkipMarker(template, day));
    },
    async performDeleteActivity({ id, activity, day }) {
      if (activity && !activity.startDate && day) {
        await this.unsubscribeAllEnrolledUsers(activity, day);
        await this.skipRecurringOnDate(activity, day);
        return;
      }

      if (activity?.startDate && activity?.relatedActivity) {
        await this.unsubscribeAllEnrolledUsers(activity);
        await deleteActivity(id);
        const template = this.activities.find((item) => item._id === activity.relatedActivity);
        if (template) {
          const classDay = day || new Date(activity.startDate);
          await this.unsubscribeAllEnrolledUsers(template, classDay);
          await this.skipRecurringOnDate(template, classDay);
        }
        return;
      }

      if (activity?.startDate) {
        await this.unsubscribeAllEnrolledUsers(activity);
      }
      await deleteActivity(id);
    },
    deleteAct(payload) {
      if (this.isDemo && this.isDemo()) {
        return;
      }

      const { id, activity, day } = this.normalizeDeletePayload(payload);
      const isRecurringOnDate = activity && !activity.startDate && day;

      Swal.fire({
        title: this.$t('areYouSure'),
        text: isRecurringOnDate
          ? this.$t('deleteRecurringOnDateText')
          : this.$t('youWontBeAbleToRevertThis'),
        type: 'warning',
        position: 'top',
        confirmButtonText: this.$t('delete'),
        showCancelButton: true,
      }).then(async (result) => {
        if (!result.isConfirmed) {
          return;
        }
        await this.performDeleteActivity({ id, activity, day });
        await this.getAll();
      });
    },
  },
};
